/* Kron Color Swatches — image swap on click. Loaded by kron-overrides bootstrap or theme.liquid. */
(function() {
  'use strict';

  function findPrimaryImage(card) {
    return card.querySelector('.product-card__image--primary')
        || card.querySelector('.product-card__media img:first-of-type')
        || card.querySelector('img');
  }

  function findCardLink(card) {
    return card.querySelector('a.product-title')
        || card.querySelector('.product-card__media a')
        || card.querySelector('a[data-instant]');
  }

  function swapImage(card, swatch) {
    var src = swatch.getAttribute('data-image');
    var srcset = swatch.getAttribute('data-image-srcset');
    if (!src) return;

    var img = findPrimaryImage(card);
    if (!img) return;

    // Set new src + srcset
    img.src = src;
    if (srcset) {
      img.srcset = srcset;
    } else {
      img.removeAttribute('srcset');
    }

    // Update card link to point to variant
    var href = swatch.getAttribute('data-href');
    if (href) {
      var links = card.querySelectorAll('a[href*="/products/"]');
      links.forEach(function(l) {
        // Preserve original product URL but update query
        var u = new URL(href, window.location.origin);
        l.href = u.pathname + u.search;
      });
    }

    // Active state — swatches inside this card
    var siblings = card.querySelectorAll('.kron-swatch');
    siblings.forEach(function(s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');
  }

  function onClick(e) {
    var swatch = e.target.closest && e.target.closest('.kron-swatch:not(.kron-swatch--more)');
    if (!swatch) return;

    // Prevent any anchor navigation when clicking the swatch
    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('product-card');
    if (!card) return;

    swapImage(card, swatch);

    // Fire PostHog event if available
    try {
      if (typeof posthog !== 'undefined' && posthog.capture) {
        posthog.capture('kron_swatch_clicked', {
          product_handle: card.getAttribute('handle') || '',
          color: swatch.getAttribute('data-color') || '',
          variant_id: swatch.getAttribute('data-variant-id') || '',
          collection: 'best-sellers'
        });
      }
    } catch (err) {}
  }

  // Capture phase so we catch before card link navigation
  document.addEventListener('click', onClick, true);
  document.addEventListener('keydown', function(e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.classList && e.target.classList.contains('kron-swatch')) {
      e.preventDefault();
      e.target.click();
    }
  });
})();

/* ============================================================
   KRON BUNDLE ENHANCE — 2026-06-11 (carregado global via swatches asset)
   quick-view = PhotoSwipe core + UI customizada IGUAL ao tema (circle-button).
   ============================================================ */
(function(){
  if (window.__kronBundleEnhance) return;
  window.__kronBundleEnhance = true;

  var ZOOM_SCHEME = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.defaultColorSchemeId) || 'scheme-1';

  function loadPSWP(){
    if (window.__kronPSWP) return Promise.resolve(window.__kronPSWP);
    if (window.__kronPSWPLoading) return window.__kronPSWPLoading;
    window.__kronPSWPLoading = new Promise(function(resolve, reject){
      var done = false;
      function finish(){ if (done) return; done = true; window.__kronPSWP ? resolve(window.__kronPSWP) : reject(new Error('pswp')); }
      window.addEventListener('kron:pswp-ready', finish, { once: true });
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = "import P from 'photoswipe'; window.__kronPSWP = P; window.dispatchEvent(new Event('kron:pswp-ready'));";
      s.onerror = function(){ if (!done) { done = true; reject(new Error('pswp load')); } };
      document.head.appendChild(s);
      setTimeout(finish, 4000);
    });
    return window.__kronPSWPLoading;
  }

  function openZoom(images, title){
    var clean = (images || []).filter(function(i){ return i && i.src; });
    if (!clean.length) return;
    loadPSWP().then(function(P){
      if (typeof P !== 'function') return fallbackLB(clean, title);
      var __kronCapW = function(u){ try{ if(!u) return u; if(/[?&]width=/.test(u)) return u; return u + (u.indexOf('?')>-1?'&':'?') + 'width=1600'; }catch(e){ return u; } };
      var ds = clean.map(function(it){ return { src: __kronCapW(it.src), width: it.width || 1200, height: it.height || 1200 }; });
      var pswp = new P({
        dataSource: ds,
        index: 0,
        preload: [1, 2],
        bgOpacity: 1,
        mainClass: 'color-scheme--' + ZOOM_SCHEME,
        showHideAnimationType: 'fade',
        wheelToZoom: true,
        close: false, zoom: false, counter: false, arrowPrev: false, arrowNext: false
      });
      pswp.on('uiRegister', function(){
        pswp.ui.registerElement({
          name: 'close-button circle-button circle-button--xl', className: '', ariaLabel: 'Close', order: 2, isButton: true,
          html: '<svg aria-hidden="true" focusable="false" fill="none" width="14" class="icon" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"/></svg>',
          onClick: function(){ pswp.close(); }
        });
        if (ds.length > 1) {
          pswp.ui.registerElement({
            name: 'previous-button circle-button circle-button--xl', className: '', ariaLabel: 'Previous', order: 1, isButton: true,
            html: '<svg aria-hidden="true" focusable="false" width="12" class="icon icon--direction-aware" viewBox="0 0 36 36"><path fill="none" stroke="currentColor" stroke-width="2" d="M35 18H3M19.5 34.5 3 18 19.5 1.5"/></svg>',
            onClick: function(){ pswp.prev(); }
          });
          pswp.ui.registerElement({
            name: 'next-button circle-button circle-button--xl', className: '', ariaLabel: 'Next', order: 3, isButton: true,
            html: '<svg aria-hidden="true" focusable="false" width="12" class="icon icon--direction-aware" viewBox="0 0 36 36"><path fill="none" stroke="currentColor" stroke-width="2" d="M1 18h32M16.5 1.5 33 18 16.5 34.5"/></svg>',
            onClick: function(){ pswp.next(); }
          });
        }
      });
      pswp.init();
    }).catch(function(){ fallbackLB(clean, title); });
  }

  /* ---- Fallback lightbox (caso o PhotoSwipe não carregue) ---- */
  var lb = null, lbImgs = [], lbIdx = 0;
  function buildLB(){
    lb = document.createElement('div');
    lb.className = 'kron-bl-overlay';
    lb.innerHTML =
      '<div class="kron-bl-stage">' +
        '<button class="kron-bl-close" aria-label="Close"><svg width="20" height="20" viewBox="0 0 12 12" fill="none"><path d="M11 1L1 11M1 1l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '<img class="kron-bl-img" alt="">' +
        '<button class="kron-bl-nav kron-bl-prev" aria-label="Previous"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>' +
        '<button class="kron-bl-nav kron-bl-next" aria-label="Next"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>' +
        '<div class="kron-bl-cap"></div>' +
        '<div class="kron-bl-dots"></div>' +
      '</div>';
    document.body.appendChild(lb);
    lb.addEventListener('click', function(e){ if (e.target === lb) closeLB(); });
    lb.querySelector('.kron-bl-close').addEventListener('click', closeLB);
    lb.querySelector('.kron-bl-prev').addEventListener('click', function(e){ e.stopPropagation(); navLB(-1); });
    lb.querySelector('.kron-bl-next').addEventListener('click', function(e){ e.stopPropagation(); navLB(1); });
    document.addEventListener('keydown', function(e){ if (!lb.classList.contains('is-open')) return; if (e.key === 'Escape') closeLB(); if (e.key === 'ArrowLeft') navLB(-1); if (e.key === 'ArrowRight') navLB(1); });
    var x0 = null;
    lb.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
    lb.addEventListener('touchend', function(e){ if (x0===null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) navLB(dx < 0 ? 1 : -1); x0 = null; }, {passive:true});
  }
  function renderLB(){
    var img = lb.querySelector('.kron-bl-img'); img.src = lbImgs[lbIdx] || '';
    var dots = lb.querySelector('.kron-bl-dots');
    dots.innerHTML = lbImgs.map(function(_,i){ return '<span class="kron-bl-dot'+(i===lbIdx?' is-active':'')+'"></span>'; }).join('');
    var many = lbImgs.length > 1;
    lb.querySelector('.kron-bl-prev').style.display = many ? '' : 'none';
    lb.querySelector('.kron-bl-next').style.display = many ? '' : 'none';
    dots.style.display = many ? '' : 'none';
  }
  function navLB(d){ if (!lbImgs.length) return; lbIdx = (lbIdx + d + lbImgs.length) % lbImgs.length; renderLB(); }
  function fallbackLB(images, title){ if (!lb) buildLB(); lbImgs = images.map(function(i){ return i.src || i; }); lbIdx = 0; lb.querySelector('.kron-bl-cap').textContent = title || ''; renderLB(); lb.classList.add('is-open'); }
  function closeLB(){ if (lb) lb.classList.remove('is-open'); }

  function enhance(el){
    if (el.__kronEnhanced) return; el.__kronEnhanced = true;
    var handle = el.dataset.collectionHandle;
    var imgMap = {};
    if (handle) {
      fetch(Shopify.routes.root + 'collections/' + handle + '/products.json?limit=50')
        .then(function(r){ return r.json(); })
        .then(function(d){ (d.products||[]).forEach(function(p){
          imgMap[p.title] = (p.images||[]).map(function(i){
            return (typeof i === 'string') ? { src: i } : { src: i.src, width: i.width, height: i.height };
          });
        }); })
        .catch(function(){});
    }

    var grids = el.querySelectorAll('[data-picker-grid], [data-variant-grid]');
    function decorate(){
      el.querySelectorAll('.bundle-picker__item').forEach(function(item){
        if (item.querySelector('.bundle-picker__view')) return;
        var titleEl = item.querySelector('.bundle-picker__item-title');
        var title = titleEl ? titleEl.textContent.trim() : '';
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'bundle-picker__view'; btn.setAttribute('aria-label', 'View photos');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
        btn.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var imgs = imgMap[title];
          if (!imgs || !imgs.length) { var im = item.querySelector('img'); imgs = im ? [{ src: im.src }] : []; }
          openZoom(imgs, title);
        });
        item.appendChild(btn);
      });
    }
    var obs = new MutationObserver(decorate);
    grids.forEach(function(g){ obs.observe(g, { childList: true }); });
    decorate();

    var filled = el.querySelector('[data-picker-filled]');
    if (filled) {
      var ensureChange = function(){
        if (filled.hidden) return;
        if (filled.querySelector('.bundle-collection-product__change')) return;
        var rm = filled.querySelector('[data-remove-product]');
        var ch = document.createElement('button');
        ch.type = 'button'; ch.className = 'bundle-collection-product__change'; ch.setAttribute('data-change-product',''); ch.textContent = 'Change';
        ch.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); if (typeof el.openPicker === 'function') el.openPicker(); });
        if (rm) filled.insertBefore(ch, rm); else filled.appendChild(ch);
      };
      ensureChange();
      new MutationObserver(ensureChange).observe(filled, { attributes: true, attributeFilter: ['hidden'] });
    }

    function bundleMode(){ var c = el.querySelector('input[name^="bundle-choice"]:checked'); return !c || c.value === 'bundle'; }
    function mainForm(){ return document.querySelector('product-form form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]'); }
    ['kron-entry-sticky-atc-btn','kron-sticky-atc-btn','kron-anchor-sticky-atc-btn'].forEach(function(id){
      var b = document.getElementById(id);
      if (!b || b.__kronBundleBound) return; b.__kronBundleBound = true;
      b.addEventListener('click', function(e){
        if (!bundleMode()) return;
        var f = mainForm(); if (!f) return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (typeof f.requestSubmit === 'function') f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }, true);
    });
  }

  function boot(){ document.querySelectorAll('bundle-offer').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* ============================================================
   KRON MEDIA SPEED — 2026-06-20
   Pre-warm product-gallery + collection-swatch images so taps
   feel instant. 44% of traffic = IG/FB in-app browser where
   on-demand lazy fetch on a Next-tap shows a visible stall and
   triggers rage-tapping. Keeps first paint light (LCP image
   stays the only forced eager one); warms the rest after load.
   ============================================================ */
(function(){
  if (window.__kronMediaSpeed) return;
  window.__kronMediaSpeed = true;

  var idle = window.requestIdleCallback || function(fn){ return setTimeout(fn, 1); };

  // 1) Product gallery: warm the most-swiped slides + prefetch the upcoming one on scroll.
  function warmGallery(){
    var gallery = document.querySelector('product-gallery');
    if (!gallery || gallery.__kronWarmed) return;
    gallery.__kronWarmed = true;
    var imgs = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__media img'));
    if (imgs.length < 2) return;

    function eager(img){
      if (!img) return;
      if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
      try { if (img.decode) img.decode().catch(function(){}); } catch(e){}
    }

    // After first paint/idle, eager-load slides 2..5 (covers the typical swipe depth).
    idle(function(){ imgs.slice(1, 5).forEach(eager); });

    // As the carousel scrolls, prefetch the next 2 slides ahead of the finger.
    var carousel = gallery.querySelector('.product-gallery__carousel') || gallery;
    var t = null;
    carousel.addEventListener('scroll', function(){
      if (t) return;
      t = setTimeout(function(){
        t = null;
        var w = carousel.clientWidth || 1;
        var cur = Math.round(carousel.scrollLeft / w);
        for (var i = cur; i <= cur + 2 && i < imgs.length; i++) eager(imgs[i]);
      }, 80);
    }, { passive: true });
  }

  // 2) Collection swatches: warm the target image the instant a finger touches it,
  //    so the src-swap on click is already cached (no flash / no re-fetch lag).
  function warmSwatch(e){
    var t = e.target;
    var sw = t && t.closest ? t.closest('.kron-swatch[data-image]') : null;
    if (!sw || sw.__kronWarmImg) return;
    sw.__kronWarmImg = true;
    var im = new Image();
    var ss = sw.getAttribute('data-image-srcset');
    if (ss) im.srcset = ss;
    im.src = sw.getAttribute('data-image');
  }
  document.addEventListener('touchstart', warmSwatch, { capture: true, passive: true });
  document.addEventListener('pointerenter', warmSwatch, true);

  function boot(){ warmGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
